import { RequestDetailsPopUp } from './RequestDetailsPopUp';
import { useBoolean } from '@fluentui/react-hooks';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';
import { VacationRequestType } from '../../../../tabs/hooks/useSummaryInfo';

interface RequestDetailsProps {
  isRequestPopupVisible: boolean;
  hideRequestPopup: () => void;
  requestId: string;
  vacationTypes: VacationType[];
  selectedYear: number;
  getSummary: (
    bonusDays?: number,
    paidDays?: number,
    requestType?: VacationRequestType
  ) => Promise<void>;
  getUserRequests: (
    statusCode?: string[],
    vacationTypeId?: string[],
    vacationTypes?: VacationType[]
  ) => Promise<void>;
  vacationType: string[];
  vacationStatus: string[];
}

export const RequestDetails = ({
  hideRequestPopup,
  isRequestPopupVisible,
  requestId,
  vacationTypes,
  selectedYear,
  getSummary,
  getUserRequests,
  vacationType,
  vacationStatus,
}: RequestDetailsProps) => {
  const [
    isCancelPopupVisible,
    { setTrue: showCancelPopup, setFalse: hideCancelPopup },
  ] = useBoolean(false);

  return (
    <div>
      {requestId && (
        <RequestDetailsPopUp
          getSummary={getSummary}
          hideRequestPopup={hideRequestPopup}
          isRequestPopupVisible={isRequestPopupVisible}
          isCancelPopupVisible={isCancelPopupVisible}
          showCancelPopup={showCancelPopup}
          hideCancelPopup={hideCancelPopup}
          requestId={requestId}
          vacationTypes={vacationTypes}
          selectedYear={selectedYear}
          getUserRequests={getUserRequests}
          vacationType={vacationType}
          vacationStatus={vacationStatus}
        />
      )}
    </div>
  );
};
